import React from "react";
import { func, node } from "prop-types";

const modalContext = React.createContext({
	close: () => {},
});

export const useModal = () => React.useContext(modalContext);

export class ModalContext extends React.Component {
	static Overlay = null;

	constructor(props) {
		super(props);
		this.state = { visible: true };
	}

	static getDerivedStateFromError() {
		return { visible: false };
	}

	componentDidCatch(error) {
		this.handleError(error);
	}

	handleError(error) {
		const { onError } = this.props;
		if (typeof onError === "function") onError(error);
	}

	handleClose = result => {
		const { onClose } = this.props;
		this.setState(state => ({ ...state, visible: false }));
		if (typeof onClose === "function") onClose(result);
	};

	render() {
		const { visible } = this.state;
		const { children } = this.props;

		if (!visible) return null;

		return (
			<modalContext.Provider value={{ close: this.handleClose }}>
				<>
					{ModalContext.Overlay && <ModalContext.Overlay />}
					{children}
				</>
			</modalContext.Provider>
		);
	}
}

ModalContext.propTypes = {
	onError: func,
	onClose: func,
	children: node.isRequired,
};
